import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../store";
import classes from "./EarTrainerSetup.module.css";

const EarTrainerQuestionTypeSelect = () => {

  const dispatch = useDispatch();
  const earTrainerQuestionType = useSelector(
    (state) => state.earTrainerQuestionType
  );
  const questionTypeChangeHandler = (event) => {
    dispatch(mainActions.setEarTrainerQuestionType(+event.target.value));
  };


  return (
    <tr>
      <td className={classes.td}>
        <select
          aria-label="Question interval name"
          className={classes.select}
          value={earTrainerQuestionType}
          onChange={questionTypeChangeHandler}
        >
          <option value="1">Show interval</option>
          <option value="2">Hide interval</option>
        </select>
      </td>
      <td>Show or hide the question’s interval name</td>
    </tr>
  );
};

export default EarTrainerQuestionTypeSelect;
